import React from 'react';
import { useTranslation } from 'react-i18next';

import Heading from 'components/atoms/Heading';
import Loading from 'components/atoms/Loading';
import Radio from 'components/atoms/Radio';
import NewsCard, { NewsCardProps } from 'components/molecules/NewsCard';
import Carousel, { NextArrow, PrevArrow } from 'components/organisms/Carousel';
import TitleSectionNews from 'components/organisms/TitleSectionNews';

interface NewsListHomeProps {
  newsList?: NewsCardProps[];
  title?: string;
  viewMoreText?: string;
  href?: string;
  target?: string;
  radioList?: {
    value: string;
    title: string;
  }[],
  selectedType?: string;
  handleSetSelectedType?: (type: string) => void;
  loading?: boolean;
}

const settingBanner = {
  dots: true,
  dotsClass: 'slick-dots o-carousel_dots',
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: <PrevArrow extendClassname="prevArrow" />,
  nextArrow: <NextArrow extendClassname="nextArrow" />,
  infinite: false,
  cssEase: 'ease-in-out',
  customPaging() {
    return (
      <span className="o-carousel_dots_main" />
    );
  },
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        dots: true,
        arrows: false,
      },
    },
  ],
};

const NewsListHome: React.FC<NewsListHomeProps> = ({
  newsList,
  title,
  viewMoreText,
  href,
  target,
  radioList,
  selectedType,
  handleSetSelectedType,
  loading,
}) => {
  const { t } = useTranslation();

  return (
    <div className="t-newsListHome">
      {
      title
      && (
      <TitleSectionNews
        title={title}
        viewMoreText={viewMoreText}
        href={href}
        target={target}
        isViewMoreMobile
      >
        <div className="t-newsListHome_radioGroup">
          {radioList?.map((item) => item.title && (
            <Radio
              id={item.value}
              name={item.value}
              value={item.value}
              checkedValue={selectedType || ''}
              key={item.value}
              onChange={() => handleSetSelectedType && handleSetSelectedType(item.value)}
            >
              {item.title}
            </Radio>
          ))}
        </div>
      </TitleSectionNews>
      )
    }
      {loading && <Loading variant="default" isShow />}
      {newsList && newsList.length > 0 && (
        <div className="t-newsListHome_list">
          <Carousel settings={settingBanner}>
            {newsList.map((item, idx) => (
              <div className="t-newsListHome_item" key={`newsListHomeItem-${idx.toString()}`}>
                <NewsCard
                  key={`news-${idx.toString()}`}
                  title={item.title}
                  date={item.date}
                  href={item.href}
                  modifiers="col-space-between"
                />
              </div>
            ))}
          </Carousel>
        </div>
      )}
      {(!loading && newsList?.length === 0) && (
        <div className="t-newsListHome_noData">
          <Heading
            type="h5"
            modifiers={['letterSpacing', '700', 'grayX11', 'center']}
            content={t('overview.no_data')}
          />
        </div>
      )}
    </div>
  );
};
NewsListHome.defaultProps = {
  newsList: undefined,
  viewMoreText: '',
  href: '/',
  title: '',
  target: '_self',
  radioList: undefined,
  selectedType: undefined,
  handleSetSelectedType: undefined,
  loading: false,
};

export default NewsListHome;
